require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./obtenir-un-casier-uniquement-tudiant-1-10-0.json") })
        }
      }, "path---obtenir-un-casier-uniquement-tudiant-1-10-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---obtenir-un-casier-uniquement-tudiant-1-10-0!./.cache/json/obtenir-un-casier-uniquement-tudiant-1-10-0.json
// module id = 508
// module chunks = 231608221292675